module.exports = __webpack_public_path__ + "img/residuos hospitalarios.21859b26.jpg";